const USER_KEY = "vt-offline-user";
const ticketsKey = (uid) => `vt-offline-tickets-${uid}`;

export const isNetworkError = (e) => !e?.response;

export const saveOfflineUser = (u) => { try { localStorage.setItem(USER_KEY, JSON.stringify(u)); } catch {} };
export const getOfflineUser = () => { try { return JSON.parse(localStorage.getItem(USER_KEY)); } catch { return null; } };

export const saveOfflineTickets = (uid, data) => {
  try { localStorage.setItem(ticketsKey(uid), JSON.stringify({ ...data, saved_at: new Date().toISOString() })); } catch {}
};
export const getOfflineTickets = (uid) => { try { return JSON.parse(localStorage.getItem(ticketsKey(uid))); } catch { return null; } };

export function prefetchSessionQrs(active) {
  const urls = (active || []).flatMap((r) => (r.sessions || []).filter((s) => s.qr_url && !s.checkin_method).map((s) => s.qr_url));
  urls.slice(0, 40).forEach((u) => fetch(`${process.env.REACT_APP_BACKEND_URL}${u}`).catch(() => {}));
}

export function clearOffline() {
  Object.keys(localStorage).filter((k) => k === USER_KEY || k.startsWith("vt-offline-tickets-") || k.startsWith("vt-att-")).forEach((k) => localStorage.removeItem(k));
  navigator.serviceWorker?.controller?.postMessage("clear-qr");
  navigator.serviceWorker?.ready?.then((r) => r.pushManager?.getSubscription()).then((s) => s?.unsubscribe()).catch(() => {});
}

export function registerOfflineWorker() {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__vtInstallPrompt = e;
    window.dispatchEvent(new Event("vt-install-ready"));
  });
  if (!("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => { navigator.serviceWorker.register("/sw.js").catch(() => {}); });
}
